import { render, staticRenderFns } from "./AccountingPointParamTable.vue?vue&type=template&id=1edf4f41&"
import script from "./AccountingPointParamTable.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointParamTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports